export default {
  meta: {
    expanded: false,
    label: "Stock Management ",
    public: false,
    auth: true,
    icon: "fa-list-alt",
    permission: [config.permission.STOCK_INDEX]
  },
  children: [
    {
      name: "Stock",
      path: "/stock",
      meta: {
        auth: true,
        label: "Live Stock",
        breadcrumb: [{ name: "Live Stock" }],
        permission: [config.permission.STOCK_INDEX]
      },
      component: () => import("views/stock/index-stock")
    },
    {
      name: "Purchase Order",
      path: "/purchase-order",
      meta: {
        label: "PO",
        public: false,
        auth: true,
        breadcrumb: [{ name: "PO" }],
        permission: [config.permission.STOCK_INDEX]
      },
      component: () => import("views/stock/PO/purchase-index")
    },
    {
      name: "purchase-order-create",
      path: "/purchase-order/create",
      meta: {
        public: false,
        auth: true,
        label: "Create",
        breadcrumb: [
          { name: "PO", link: "/purchase-order" },
          { name: "Create" }
        ]
      },
      component: () => import("views/stock/PO/purchase-order")
    },
    {
      name: "purchase-order-edit",
      path: "/purchase-order/edit/:id",
      meta: {
        public: false,
        auth: true,
        breadcrumb: [{ name: "PO", link: "/purchase-order" }],
        label: "Edit"
      },
      component: () => import("views/stock/PO/purchase-edit")
    },
    {
      name: "pos",
      path: "/pos",
      meta: {
        label: "POS",
        breadcrumb: [{ name: "POS" }],
        permission: [config.permission.STOCK_INDEX]
      },
      component: () => import("views/stock/POS/pos-index")
    },
    {
      name: "pos-create",
      path: "/pos/create",
      meta: {
        auth: true,
        breadcrumb: [{ name: "POS", link: "/pos" }, { name: "Create" }],
        label: "Create"
      },
      component: () => import("views/stock/POS/pos-create")
    },
    {
      name: "pos-edit",
      path: "/pos/edit/:id",
      meta: {
        auth: true,
        label: "Edit",
        breadcrumb: [{ name: "POS", link: "/pos" }]
      },
      component: () => import("views/stock/POS/pos-edit")
    },
    {
      name: "Stock Adjustment",
      path: "/adjustment",
      meta: {
        auth: true,
        label: "Adjustment Logs",
        breadcrumb: [{ name: "Adjustment Logs" }],
        permission: [config.permission.STOCK_INDEX]
      },
      component: () => import("views/stock/adjustment/index")
    }
  ]
};
